
import { createContext } from "react";

import { GetParticipantByLabelResponse } from "@/apis/dtos";
import useGetParticipantByLabel from "@/hooks/data/useGetParticipantByLabel";

export type ParticipantContextData = Omit<GetParticipantByLabelResponse, "responseStatus">;

export interface IParticipantContext extends Omit<ReturnType<typeof useGetParticipantByLabel>, 'data' | 'total' | 'offset'> {
    data?: ParticipantContextData
}

const ParticipantContext = createContext<IParticipantContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantContext;